module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, [_vm._l((_vm.items), function(item, i) {
    return [_c('div', {
      staticClass: "item",
      attrs: {
        "data-item-id": ("" + i)
      }
    }, [_vm._l((item.slide), function(itm, j) {
      return _c('div', {
        staticClass: "imgContainer",
        class: j == 0 ? 'active' : '',
        style: (("background-image: url('" + (itm.src) + "')")),
        attrs: {
          "data-id": (i + "-" + j)
        }
      })
    }), _vm._v(" "), (item.slide[0].color) ? _c('div', {
      staticClass: "bottomBar"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('p', [_vm._v(_vm._s(_vm.data.button_text))]), _vm._v(" "), _c('div', {
      staticClass: "colorChoice"
    }, _vm._l((item.slide), function(itm, j) {
      return (itm.color) ? _c('div', {
        staticClass: "color",
        class: j == 0 ? 'active' : '',
        style: (("background-color: " + (itm.color) + ";")),
        on: {
          "click": function($event) {
            return _vm.change($event, itm.color, (i + "-" + j))
          }
        }
      }) : _vm._e()
    }), 0)])]) : _vm._e()], 2)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05cbea92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/product_slider.vue
// module id = 374
// module chunks = 14